import React, { useContext } from 'react'

import imgTemp from '../../../assets/imgs/libro_bitcoin/libros-reg2.png';
import PopupBooks from '../../../components/popupBitcoin/popupBitcoin'
 import { PopupContext } from '../../../context/PopupContext'
import { useTranslation } from 'react-i18next'
//import { PopupContext } from '../../../components/popup/popupBooks22'
import useMediaQuery from '@material-ui/core/useMediaQuery';







// \src\components\popup\popupBooks.jsx

// C:\git_clonado\new_sus_cambios\rbs-2023\src\context\PopupContext.jsx
export const PopupContainer = () => {
    const isMobile = useMediaQuery('(max-width: 768px)');

    const { visible, setVisible } = useContext(PopupContext)
    const [t, i18n] = useTranslation('global');

    return (
        <>
  {visible ? (
    isMobile ? (
      <PopupBooks
        // imgTemp={imgTemp}
        // titleLeft={t('title.left')}
        titleRigth={t('title.right')}
      />
    ) : (
      <PopupBooks
        imgTemp={imgTemp}
        titleLeft={t('title.left')}
        titleRigth={t('title.right')}
      />
    )
  ) : (
    <div></div>
  )}
</>

    );

}
